import { DlpTrackCountPerGroupType, DlpTrackCountPerUserType, DlpTrackCountType, CostsPerAssistantType, CostsPerChatModelType, CostsPerEmbeddingModelType, PerDayType, PerGroupType, PerUserType } from '../Types';
import requestClient from '../components/Utility/RequestClient';

export const dashboardService = {
    getLicences: async (demo: boolean): Promise<{ data: { used: number; free: number } }> => {
        return requestClient.get(`${demo ? '/demo' : ''}/dashboard/licences`);
    },

    getTotalCost: async (demo: boolean): Promise<{ data: number }> => {
        return requestClient.get(`${demo ? '/demo' : ''}/dashboard/totalcosts`);
    },

    getTotalCredit: async (demo: boolean): Promise<{ data: number }> => {
        return requestClient.get(`${demo ? '/demo' : ''}/dashboard/totalcredit`);
    },

    getTotalCostByDate: async (demo: boolean, from: string, to: string): Promise<{ data: number }> => {
        return requestClient.get(`${demo ? '/demo' : ''}/dashboard/totalcosts?fromDateTime=${from}&toDateTime=${to}`);
    },

    getAverageCostByDate: async (demo: boolean, from: string, to: string): Promise<{ data: number }> => {
        return requestClient.get(
            `${demo ? '/demo' : ''}/dashboard/totalcostsavg?fromDateTime=${from}&toDateTime=${to}`,
        );
    },

    getCostPerDay: async (demo: boolean, from: string, to: string): Promise<{ data: PerDayType[] }> => {
        return requestClient.get(`${demo ? '/demo' : ''}/dashboard/costsperday?fromDateTime=${from}&toDateTime=${to}`);
    },

    getUserStatistics: async (demo: boolean, from: string, to: string): Promise<{ data: PerUserType[] }> => {
        return requestClient.get(`${demo ? '/demo' : ''}/dashboard/costsperuser?fromDateTime=${from}&toDateTime=${to}`);
    },

    getCostPerGroup: async (demo: boolean, from: string, to: string): Promise<{ data: PerGroupType[] }> => {
        return requestClient.get(
            `${demo ? '/demo' : ''}/dashboard/costspergroup?fromDateTime=${from}&toDateTime=${to}`,
        );
    },

    getCostsPerAssistant: async (from: string, to: string, page: number, itemsPerPage: number, query?: string | null): Promise<{ data: { data: CostsPerAssistantType[]; total: number } }> => {
        return requestClient.get(
            `/dashboard/costsperassistant`,{
                params: {
                    fromDateTime: from,
                    toDateTime: to,
                    page,
                    itemsPerPage,
                    query,
                },
            }
        );
    },

    getCostsPerChatModel: async (from: string, to: string, page: number, itemsPerPage: number, query?: string | null): Promise<{ data: { data: CostsPerChatModelType[]; total: number } }> => {
        return requestClient.get(
            `/dashboard/costsperchatmodel`,{
                params: {
                    fromDateTime: from,
                    toDateTime: to,
                    page,
                    itemsPerPage,
                    query,
                },
            }
        );
    },

    getCostsPerEmbeddingModel: async (from: string, to: string, page: number, itemsPerPage: number, query?: string | null): Promise<{ data: { data: CostsPerEmbeddingModelType[]; total: number } }> => {
        return requestClient.get(
            `/dashboard/costsperembeddingmodel`,{
                params: {
                    fromDateTime: from,
                    toDateTime: to,
                    page,
                    itemsPerPage,
                    query,
                },
            }
        );
    },

    getTotalDlpTrackCount: async (demo: boolean, from: string, to: string): Promise<{ data: DlpTrackCountType }> => {
        return requestClient.get(
            `${demo ? '/demo' : ''}/dashboard/totaldlptrackcount?fromDateTime=${from}&toDateTime=${to}`,
        );
    },

    getDlpTrackCountPerUser: async (from: string, to: string, page: number, itemsPerPage: number, query?: string | null): Promise<{ data: { data: DlpTrackCountPerUserType[]; total: number } }> => {
        return requestClient.get(
            `/dashboard/dlptrackcountperuser`,{
                params: {
                    fromDateTime: from,
                    toDateTime: to,
                    page,
                    itemsPerPage,
                    query,
                },
            }
        );
    },

    getDlpTrackCountPerGroup: async (from: string, to: string, page: number, itemsPerPage: number, query?: string | null): Promise<{ data: { data: DlpTrackCountPerGroupType[]; total: number } }> => {
        return requestClient.get(
            `/dashboard/dlptrackcountpergroup`,{
                params: {
                    fromDateTime: from,
                    toDateTime: to,
                    page,
                    itemsPerPage,
                    query,
                },
            }
        );
    },

    getExport: async (demo: boolean, from: string, to: string): Promise<{ data: any }> => {
        return requestClient.get(`${demo ? '/demo' : ''}/dashboard/export?fromDateTime=${from}&toDateTime=${to}`);
    },
};
